import React from 'react';
import { ASubheader } from '../../atoms/ASubheader';
import { MListTextIcon } from '../MListTextIcon';
import { Wrapper, List, ListItem } from './MListTextGroupVertical.styles';
import { type MListTextGroupVerticalProps } from './MListTextGroupVertical.types';

const COMPONENT_NAME = 'm-web-ui-kit-MListTextGroupVertical';
const TEST_ID = 'web-ui-kit-MListTextGroupVertical';

function MListTextGroupVertical({ showSubheader, aSubheader, items = [], ...rest }: MListTextGroupVerticalProps) {
  return (
    <Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      {showSubheader && aSubheader && <ASubheader {...aSubheader} />}
      <List>
        {items.map((item, index) => (
          <ListItem key={index} data-testid="m-list-text-group-vertical-item">
            <MListTextIcon {...item} />
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
}

export { MListTextGroupVertical, TEST_ID as M_LIST_TEXT_GROUP_VERTICAL_TEST_ID };
